import React from "react";

const Spinner = React.memo(({ isLoading }) => {
  return (
    <>
      {isLoading && (
        <div className="overlay">
          <div className="spinner-container">
            <div className="spinner"></div>
          </div>
        </div>
      )}
    </>
  );
});

export default Spinner;
